module.exports = {
        colors: {
          primary: "#F81894",
          text: "#FFFFF",
          buttonText: "#000000",
          icons: "#F81894",
        },

        fontFamily: '"Cardo", serif !important',
        css: `
      .button { background: #32CD32; border-radius: 0.2rem; }

        @import url("https://fonts.googleapis.com/css2?family=Cardo:wght@400;700&display=swap");
  
        .ReactDialogBackground {
          background: rgba(0,0,0,0.8);
        }
      `,
}